export enum RoomStructureItemType {
  Header = 'header',
  Content = 'content',
  TextBox = 'text_box',
  Folder = 'folder', // TODO: BACKEND - Add this new type
}

export const RoomContentTypes = [
  RoomStructureItemType.Content,
  RoomStructureItemType.TextBox,
];
